// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"style_tabsContainer__2WiwX","buttonContainer":"style_buttonContainer__19VGx","selected":"style_selected__1KlPG","tabsContent":"style_tabsContent___enKz"};